import { render, staticRenderFns } from "./TrademarkTransactionReport.vue?vue&type=template&id=a3feb016&"
import script from "./TrademarkTransactionReport.vue?vue&type=script&lang=js&"
export * from "./TrademarkTransactionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports